import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER } from "./actionTypes";
import { apiError, loginUserSuccessful } from "./actions";

// AUTH related methods
import { postLogin, postAdd } from "../../../helpers/Helper";
// import { getFirebaseBackend } from '../../../helpers/firebase_helper';

//Initilize firebase
// const fireBaseBackend = getFirebaseBackend();

//If user is login then dispatch redux action's are directly from here.
function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, "/users/login/", {
      username: user.username,
      password: user.password,
    });
    // localStorage.setItem("authUser", JSON.stringify(response));
    localStorage.setItem("access_token", response.tokens.access);
    localStorage.setItem("refresh_token", response.tokens.refresh);
    localStorage.setItem("username", response.username);
    localStorage.setItem("User_full_name", response.full_name);
    localStorage.setItem("location_id", response.location);
    localStorage.setItem("departments", response.departments);
    localStorage.setItem("hod_to", response.hod_to);

    yield put(loginUserSuccessful(response));
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    yield call(postAdd, "/users/logout/", {
      refresh: localStorage.getItem("refresh_token"),
    });

    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("User_full_name");

    history.push("/login");
  } catch (error) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("User_full_name");

    yield put(apiError(error));
  }
}

export function* watchUserLogin() {
  yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
}

export default loginSaga;
